import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl/dist';

import Plan from './Plan';
import { getStatus } from '../../../../utils/dashboard/processCommon';

const FavoritePlans = (props) => {
    const {
        type,
        favPlans,
        status,
        link,
        handleClick
    } = props;

    const processedFavPlans = favPlans.map(favPlan => (
        <div key={favPlan.planId}
            className="grid-row padding-2"
        >
            <div className="tablet:grid-col-5 padding-x-2">
                <Plan plan={favPlan} />
            </div>
            <div className="tablet:grid-col-4 padding-x-2">
                { getStatus(type, favPlan.planId, status) }
            </div>
            { link &&
                <div className="tablet:grid-col-3 padding-x-2">
                    <div className="text-underline">
                        <a href="#"
                            onClick={handleClick}
                        >
                            <FormattedMessage id={link}/>
                        </a>
                    </div>
                </div>
            }
        </div>
    ));
    return (
        <Fragment>
            {processedFavPlans}
        </Fragment>);
};

export default FavoritePlans;